import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueYouTubeEmbed from 'vue-youtube-embed'
import LoadScript from 'vue-plugin-load-script'
import VModal from 'vue-js-modal'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import '@/assets/css/game-window.css'
import '@/assets/css/ro-supplemental.css'
import '@/assets/css/on-boarding.css'

Bugsnag.start({
  apiKey: '360321d9aa2e2d84ad52bd6a5d51eefe',
  plugins: [new BugsnagPluginVue(Vue)]
})

Vue.use(VueYouTubeEmbed)
Vue.use(LoadScript)
Vue.use(VModal, {
  dialog: true
})

Vue.config.productionTip = false

Vue.prototype.$constants = {
  INTRO_CHALLENGE_INDEX: -2,
  GAMEBOARD_CHALLENGE_INDEX: -1
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
